// General
import React, { useState, useContext } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { Autocomplete, TextField } from "@mui/material";
// Contexts
import { ActionContext } from "../../../data/action/ActionContext";
import { SubActionContext } from "../../../data/action/SubActionContext";
import { PersonelContext } from "../../../data/personel/PersonelContext";

function ServiceActionAddModal({ show, handleClose, onSubmit }) {
  const { actions } = useContext(ActionContext);
  const { subActions } = useContext(SubActionContext);
  const { personelList } = useContext(PersonelContext);

  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedSubAction, setSelectedSubAction] = useState(null); 

  const filteredSubActions = selectedAction
    ? subActions.filter((s) => selectedAction.subActions.includes(s.id))
    : [];

  const fieldWrapperStyle = { marginBottom: "0.5rem" };

  const renderExtraField = (sub, values, setFieldValue) => {
    const extra = values.extra || {};

    switch (sub.name) {
      case "Yerinde Bakım Yapıldı":
        return (
          <div key={sub.id} className="mb-3">
            <div className="row mb-2">
              <div className="col-md-6" style={fieldWrapperStyle}>
                <Field
                  name={`extra.${sub.id}.performed`}
                  as={TextField}
                  label="Yapılan İşlem"
                  size="small"
                  fullWidth
                />
              </div>
              <div className="col-md-6" style={fieldWrapperStyle}>
                <Field
                  name={`extra.${sub.id}.amount`}
                  as={TextField}
                  type="number"
                  label="TL"
                  size="small"
                  fullWidth
                />
              </div>
            </div>
            <div className="row">
              <div className="col" style={fieldWrapperStyle}>
                <Field
                  name={`extra.${sub.id}.note`}
                  as={TextField}
                  label="Açıklama"
                  size="small"
                  fullWidth
                />
              </div>
            </div>
          </div>
        );

      case "Haber Verecek":
      case "Müşteri İptal Etti":
      case "Teyid Araması":
      case "Cihaz Tamir Edilemiyor":
      case "Şikayetçi":
      case "Yeniden Teknisyen Yönlendir":
      case "Servis Sonlandırıldı":
        return (
          <div key={sub.id} className="row mb-3">
            <div className="col" style={fieldWrapperStyle}>
              <Field
                name={`extra.${sub.id}.note`}
                as={TextField}
                label="Açıklama"
                size="small"
                fullWidth
              />
            </div>
          </div>
        );

      case "Tahsilata Gönder":
        return (
          <div key={sub.id} className="mb-3">
            <div className="row mb-2">
              <div className="col-md-6" style={fieldWrapperStyle}>
                <Field
                  name={`extra.${sub.id}.paymentDate`}
                  as={TextField}
                  type="date"
                  label="Ödeme Tarihi"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={extra[sub.id]?.paymentDate || ""}
                />
              </div>
              <div className="col-md-6" style={fieldWrapperStyle}>
                <Field
                  name={`extra.${sub.id}.amount`}
                  as={TextField}
                  type="number"
                  label="Ödeme TL"
                  size="small"
                  fullWidth
                  value={extra[sub.id]?.amount || ""}
                />
              </div>
            </div>
            <div className="row">
              <div className="col" style={fieldWrapperStyle}>
                <Autocomplete
                  options={personelList}
                  getOptionLabel={(option) => option.fullName || option.name}
                  value={extra[sub.id]?.personnel || null}
                  onChange={(e, value) =>
                    setFieldValue(`extra.${sub.id}.personnel`, value)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Personel Seç"
                      size="small"
                      fullWidth
                    />
                  )}
                />
              </div>
            </div>
          </div>
        );

      case "Müşteriye Ulaşılamadı":
        const callTimeOptions = [
          "09:00-10:00", "10:00-11:00", "11:00-12:00", "12:00-13:00",
          "13:00-14:00", "14:00-15:00", "15:00-16:00", "16:00-17:00",
          "17:00-18:00", "18:00-19:00",
        ];
        return (
          <div key={sub.id} className="mb-3">
            <div className="row g-2">
              <div className="col-3">
                <Autocomplete
                  options={callTimeOptions}
                  value={extra[sub.id]?.callTime || ""}
                  onChange={(e, value) =>
                    setFieldValue(`extra.${sub.id}.callTime`, value)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Arama Saati Aralığı"
                      size="small"
                      fullWidth
                    />
                  )}
                />
              </div>
              <div className="col-9">
                <Field
                  name={`extra.${sub.id}.note`}
                  as={TextField}
                  label="Açıklama"
                  size="small"
                  fullWidth
                />
              </div>
            </div>
          </div>
        );

      case "Parça Gidecek":
      case "Atölyeye Alındı":
      case "Parçası Atölyeye Alındı":
        return (
          <div key={sub.id} className="mb-3">
            <div className="row mb-2">
              <div className="col" style={fieldWrapperStyle}>
                <Field
                  name={`extra.${sub.id}.price`}
                  as={TextField}
                  type="number"
                  label="Müşteriye Verilen Fiyat"
                  size="small"
                  fullWidth
                />
              </div>
            </div>
            <div className="row">
              <div className="col" style={fieldWrapperStyle}>
                <Field
                  name={`extra.${sub.id}.actions`}
                  as={TextField}
                  label="Yapılacak İşlemler"
                  size="small"
                  fullWidth
                  multiline
                  minRows={3}
                />
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Formik
        enableReinitialize
        initialValues={{ extra: {} }}
        onSubmit={(values) => {
          if (!selectedAction || !selectedSubAction) return;
          onSubmit({
            actionId: selectedAction.id,
            subActions: [selectedSubAction.id], // Tek seçim
            extraData: values.extra,
          });
          setSelectedAction(null);
          setSelectedSubAction(null);
          handleClose();
        }}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Servis Aksiyon Ekle</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="row mb-3">
                <div className="col" style={fieldWrapperStyle}>
                  <Autocomplete
                    options={actions}
                    getOptionLabel={(option) => option.name}
                    value={selectedAction}
                    onChange={(e, newValue) => {
                      setSelectedAction(newValue);
                      setSelectedSubAction(null);
                      setFieldValue("extra", {});
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Servis Durumu Seç" size="small" fullWidth />
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col" style={fieldWrapperStyle}>
                  <Autocomplete
                    options={filteredSubActions}
                    getOptionLabel={(option) => option.name}
                    value={selectedSubAction}
                    onChange={(e, newValue) => {
                      setSelectedSubAction(newValue);
                      setFieldValue("extra", {});
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Yapılacak İşlem" size="small" fullWidth />
                    )}
                    disabled={!selectedAction}
                  />
                </div>
              </div>

              {selectedSubAction && renderExtraField(selectedSubAction, values, setFieldValue)}
            </Modal.Body>

            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={handleClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default ServiceActionAddModal;
